import type { UserSubscriptionStatus } from '../types/subscription';

export interface ActiveSubscriptionPlanBadgeInfo {
  planName: string;
  icon?: string;
  color?: string;
}

export function normalizeUserSubscriptionStatus(raw: unknown): UserSubscriptionStatus {
  const r = (raw && typeof raw === 'object' ? raw : {}) as Record<string, unknown>;
  const hasActive = Boolean(r.hasActiveSubscription ?? r.HasActiveSubscription);
  const isTrialActive = Boolean(r.isTrialActive ?? r.IsTrialActive);
  const remainingSub = Number(r.remainingSubscriptionDays ?? r.RemainingSubscriptionDays ?? 0);
  const remainingTrial = Number(r.remainingTrialDays ?? r.RemainingTrialDays ?? 0);
  const trialEnd = (r.trialEndDate ?? r.TrialEndDate) as string | undefined;
  const subEnd = (r.subscriptionEndDate ?? r.SubscriptionEndDate) as string | undefined;
  const current = (r.currentSubscription ?? r.CurrentSubscription) as Record<string, unknown> | undefined;
  const plan = (current?.subscriptionPlan ?? current?.SubscriptionPlan) as Record<string, unknown> | undefined;
  const planName = (plan?.name ?? plan?.Name) as string | undefined;
  const planId = Number(plan?.id ?? plan?.Id ?? 0) || undefined;
  const planIcon = (plan?.icon ?? plan?.Icon) as string | undefined;
  const planColor = (plan?.color ?? plan?.Color) as string | undefined;
  const startDate = (current?.startDate ?? current?.StartDate) as string | undefined;
  const endDate = (current?.endDate ?? current?.EndDate ?? subEnd) as string | undefined;

  return {
    isActive: hasActive,
    planName,
    startDate,
    endDate,
    remainingDays: hasActive ? remainingSub : 0,
    isTrialActive,
    trialEndDate: trialEnd,
    trialRemainingDays: remainingTrial,
    currentSubscription: planId
      ? {
          subscriptionPlan: {
            id: planId,
            name: planName,
            icon: planIcon,
            color: planColor
          }
        }
      : hasActive && planName
        ? { subscriptionPlan: { id: 0, name: planName, icon: planIcon, color: planColor } }
        : undefined
  };
}

export function getActivePlanBadgeInfo(
  status: UserSubscriptionStatus | null | undefined
): ActiveSubscriptionPlanBadgeInfo | null {
  if (!status?.isActive) return null;
  const plan = status.currentSubscription?.subscriptionPlan;
  const name = plan?.name ?? status.planName;
  if (!name) return null;
  return {
    planName: name,
    icon: plan?.icon,
    color: plan?.color
  };
}
